// THIS FILE WAS GENERATED BY @labelbox/flags. DO NOT EDIT ....
export enum FlagNames {
  EnableGqlExplorer = 'enable-gql-explorer',
  WorkrampWebhookEmailFilter = 'workramp-webhook-email-filter',
  Admin = 'admin',
  IntercomAppIdOverride = 'intercom-app-id-override',
  WhoCanImpersonate = 'who-can-impersonate',
  FunnelOptimization = 'funnel-optimization',
  EnableUserBackfill = 'enable-user-backfill',
  RolesAssessmentsRework = 'roles-assessments-rework',
  RoleAdmin = 'role-admin',
  NewHomepage = 'new-homepage',
  AxiosDemo = 'axios-demo',
  BackgroundCheckDoneCountryBlacklist = 'background-check-done-country-blacklist',
  DiscourseUserIntegration = 'discourse-user-integration',
  AdvancedTools = 'advanced-tools',
  KycStatusCheck = 'kyc-status-check',
  AllowDuplicatePhoneNumbers = 'allow-duplicate-phone-numbers',
  HilProjectEnabled = 'hil-project-enabled',
  LabelingAssessment = 'labeling-assessment',
  HilExportCronJobEnabled = 'hil-export-cron-job-enabled',
  AiInterviewPrompts = 'ai-interview-prompts',
  AiScreeningSystemPrompt = 'ai-screening-system-prompt',
  AlignerrEarningsUserIdOverride = 'alignerr-earnings-user-id-override',
  FlowEditorUi = 'flow-editor-ui',
  HitlMultiLanguageProjects = 'hitl-multi-language-projects',
  HandshakeSso = 'handshake-sso',
  SpecilaizationSignupInput = 'specilaization-signup-input',
  WorkrampCronSync = 'workramp-cron-sync',
  PersonaEnabled = 'persona-enabled',
  PersonaAuthEnabled = 'persona-auth-enabled',
  AiInterviewEndInterviewTool = 'ai-interview-end-interview-tool',
  ProdFlowAdmin = 'prod-flow-admin',
  HITLLanguageProjectId = 'HITLLanguageProjectId',
  KillDeel = 'kill-deel',
  ImpersonateUsers = 'ImpersonateUsers',
  TalentScoutWithTrebuchet = 'TalentScoutWithTrebuchet',
  StatusPageIntegration = 'status-page-integration',
  ForcePartiallyDegradedStatus = 'force-partially-degraded-status',
  AiInterviewMasterPrompt = 'ai-interview-master-prompt',
  UseNewAiInterviewSystemPrompt = 'use-new-ai-interview-system-prompt',
  GreenhouseInterviewEnabled = 'GreenhouseInterviewEnabled',
  AiSummaryAsyncUpdate = 'ai-summary-async-update',
  HomePageRedesignV2 = 'HomePageRedesignV2',
  StripePaypalLiveTest = 'stripe-paypal-live-test',
  AiInterviewProvider = 'ai-interview-provider',
  InAppAnalytics = 'in-app-analytics',
  PayPerTask = 'pay-per-task',
  TimeRates = 'time-rates',
  SignUpFlowV2 = 'SignUpFlowV2',
  RetryFailedPaymentsCron = 'retry-failed-payments-cron',
  AllowCreatingPayments = 'allow-creating-payments',
  EnableAchievements = 'enable-achievements',
  WiseIntegration = 'wise-integration',
  DiscordCompetitorPrompt = 'discord-competitor-prompt',
  DiscordProjectAvailabilitySpamPrompt = 'discord-project-availability-spam-prompt',
  CustomerBilling = 'customer-billing',
  AiInterviewPromptOverride = 'ai-interview-prompt-override',
  AiInterviewExtraAssessments = 'ai-interview-extra-assessments',
  BannedAlignerrUsStates = 'banned-alignerr-us-states',
  AiInterviewTemplateAdmin = 'ai-interview-template-admin',
  EnableBannedCountry = 'enable-banned-country',
  TrustAndSafetyQueue = 'trust-and-safety-queue',
  LinkedInSso = 'linked-in-sso',
  BlockNeedsReviewSignUp = 'block-needs-review-sign-up',
  AlignerrWebinarUrl = 'alignerr-webinar-url',
  HubstaffOnboardingStep = 'hubstaff-onboarding-step',
  HubstaffCronJob = 'hubstaff-cron-job',
  WiseOverride = 'wise-override',
  CheckIfJwtBlocked = 'check-if-jwt-blocked',
  AddSignUpCheck = 'add-sign-up-check',
  AllowChangingLivedInAddress = 'allow-changing-lived-in-address',
  TurnOffPersonaTsCaseCreation = 'turn-off-persona-ts-case-creation',
  DontAssignFraudCases = 'dont-assign-fraud-cases',
  UpdateUpworkContractId = 'update-upwork-contract-id',
  RequirePersonaReverificationToLogin = 'require-persona-reverification-to-login',
  HubstaffFraudCron = 'hubstaff-fraud-cron',
  AlignerrReferralSystem = 'alignerr-referral-system',
  CaseQueueMode = 'case-queue-mode',
  AlignerrJobSelection = 'alignerr-job-selection',
  MaxAlignerrJobs = 'max-alignerr-jobs',
  AllowBypassingBannedStates = 'allow-bypassing-banned-states',
  ExcessiveLabelingTimeFraudDetectionCronJob = 'excessive-labeling-time-fraud-detection-cron-job',
  ExcessiveOverallTimeFraudDetectionCronJob = 'excessive-overall-time-fraud-detection-cron-job',
  AllowShadowBanning = 'allow-shadow-banning',
  UseInternetSpeedTester = 'use-internet-speed-tester',
}

export type BooleanFlag<T extends FlagNames> = Record<T, boolean>;
export type MultivariantFlag<T extends FlagNames, V> = Record<T, V>;
export type FeatureFlags = BooleanFlag<FlagNames.EnableGqlExplorer> &
  BooleanFlag<FlagNames.WorkrampWebhookEmailFilter> &
  BooleanFlag<FlagNames.Admin> &
  MultivariantFlag<FlagNames.IntercomAppIdOverride, string> &
  BooleanFlag<FlagNames.WhoCanImpersonate> &
  BooleanFlag<FlagNames.FunnelOptimization> &
  BooleanFlag<FlagNames.EnableUserBackfill> &
  BooleanFlag<FlagNames.RolesAssessmentsRework> &
  BooleanFlag<FlagNames.RoleAdmin> &
  BooleanFlag<FlagNames.NewHomepage> &
  BooleanFlag<FlagNames.AxiosDemo> &
  BooleanFlag<FlagNames.BackgroundCheckDoneCountryBlacklist> &
  BooleanFlag<FlagNames.DiscourseUserIntegration> &
  BooleanFlag<FlagNames.AdvancedTools> &
  BooleanFlag<FlagNames.KycStatusCheck> &
  BooleanFlag<FlagNames.AllowDuplicatePhoneNumbers> &
  BooleanFlag<FlagNames.HilProjectEnabled> &
  BooleanFlag<FlagNames.LabelingAssessment> &
  BooleanFlag<FlagNames.HilExportCronJobEnabled> &
  MultivariantFlag<FlagNames.AiInterviewPrompts, Record<string, any>> &
  MultivariantFlag<FlagNames.AiScreeningSystemPrompt, string> &
  MultivariantFlag<
    FlagNames.AlignerrEarningsUserIdOverride,
    Record<string, any>
  > &
  BooleanFlag<FlagNames.FlowEditorUi> &
  BooleanFlag<FlagNames.HitlMultiLanguageProjects> &
  BooleanFlag<FlagNames.HandshakeSso> &
  BooleanFlag<FlagNames.SpecilaizationSignupInput> &
  BooleanFlag<FlagNames.WorkrampCronSync> &
  BooleanFlag<FlagNames.PersonaEnabled> &
  BooleanFlag<FlagNames.PersonaAuthEnabled> &
  BooleanFlag<FlagNames.AiInterviewEndInterviewTool> &
  BooleanFlag<FlagNames.ProdFlowAdmin> &
  MultivariantFlag<FlagNames.HITLLanguageProjectId, string> &
  BooleanFlag<FlagNames.KillDeel> &
  BooleanFlag<FlagNames.ImpersonateUsers> &
  BooleanFlag<FlagNames.TalentScoutWithTrebuchet> &
  BooleanFlag<FlagNames.StatusPageIntegration> &
  BooleanFlag<FlagNames.ForcePartiallyDegradedStatus> &
  MultivariantFlag<FlagNames.AiInterviewMasterPrompt, string> &
  BooleanFlag<FlagNames.UseNewAiInterviewSystemPrompt> &
  BooleanFlag<FlagNames.GreenhouseInterviewEnabled> &
  BooleanFlag<FlagNames.AiSummaryAsyncUpdate> &
  BooleanFlag<FlagNames.HomePageRedesignV2> &
  BooleanFlag<FlagNames.StripePaypalLiveTest> &
  MultivariantFlag<FlagNames.AiInterviewProvider, string> &
  BooleanFlag<FlagNames.InAppAnalytics> &
  BooleanFlag<FlagNames.PayPerTask> &
  BooleanFlag<FlagNames.TimeRates> &
  BooleanFlag<FlagNames.SignUpFlowV2> &
  BooleanFlag<FlagNames.RetryFailedPaymentsCron> &
  BooleanFlag<FlagNames.AllowCreatingPayments> &
  BooleanFlag<FlagNames.EnableAchievements> &
  BooleanFlag<FlagNames.WiseIntegration> &
  MultivariantFlag<FlagNames.DiscordCompetitorPrompt, string> &
  MultivariantFlag<FlagNames.DiscordProjectAvailabilitySpamPrompt, string> &
  BooleanFlag<FlagNames.CustomerBilling> &
  MultivariantFlag<FlagNames.AiInterviewPromptOverride, string> &
  MultivariantFlag<FlagNames.AiInterviewExtraAssessments, Record<string, any>> &
  MultivariantFlag<FlagNames.BannedAlignerrUsStates, Record<string, any>> &
  BooleanFlag<FlagNames.AiInterviewTemplateAdmin> &
  BooleanFlag<FlagNames.EnableBannedCountry> &
  BooleanFlag<FlagNames.TrustAndSafetyQueue> &
  BooleanFlag<FlagNames.LinkedInSso> &
  BooleanFlag<FlagNames.BlockNeedsReviewSignUp> &
  MultivariantFlag<FlagNames.AlignerrWebinarUrl, string> &
  BooleanFlag<FlagNames.HubstaffOnboardingStep> &
  BooleanFlag<FlagNames.HubstaffCronJob> &
  BooleanFlag<FlagNames.WiseOverride> &
  BooleanFlag<FlagNames.CheckIfJwtBlocked> &
  BooleanFlag<FlagNames.AddSignUpCheck> &
  BooleanFlag<FlagNames.AllowChangingLivedInAddress> &
  BooleanFlag<FlagNames.TurnOffPersonaTsCaseCreation> &
  BooleanFlag<FlagNames.DontAssignFraudCases> &
  BooleanFlag<FlagNames.UpdateUpworkContractId> &
  BooleanFlag<FlagNames.RequirePersonaReverificationToLogin> &
  BooleanFlag<FlagNames.HubstaffFraudCron> &
  BooleanFlag<FlagNames.AlignerrReferralSystem> &
  BooleanFlag<FlagNames.CaseQueueMode> &
  BooleanFlag<FlagNames.AlignerrJobSelection> &
  MultivariantFlag<FlagNames.MaxAlignerrJobs, number> &
  BooleanFlag<FlagNames.AllowBypassingBannedStates> &
  BooleanFlag<FlagNames.ExcessiveLabelingTimeFraudDetectionCronJob> &
  BooleanFlag<FlagNames.ExcessiveOverallTimeFraudDetectionCronJob> &
  BooleanFlag<FlagNames.AllowShadowBanning> &
  BooleanFlag<FlagNames.UseInternetSpeedTester>;
